import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "left",
  "use": "left-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"left\"><defs><style></style></defs><path d=\"M641.28 278.613l-45.227-45.226L317.42 512.149l278.613 278.486 45.248-45.27-233.365-233.237z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol